module.exports = __webpack_public_path__ + "static/media/login-logo.b7eddc8f.png";